export enum ObservationStatus {
  CANNOT_OBSERVE = "Other",
  OBSERVED = "Observed",
  NOT_OBSERVED = "Not Observed",
}
